export default __webpack_public_path__ + "static/veterans-hero-4c33324e3fb1d20669030adf1088f710.webp";